import { t } from 'i18next';
import * as ClaimService from '../../Services/claim-service';
import { useState } from 'react';
import ClaimRequestInfo from './claim-request-info';
import { CustomAutocomplete } from '../../Components/custom-combobox/CustomAutocomplete';
import { handleChangeEventTextContent } from '../../Services/pos-service';
import { useNavigate } from 'react-router-dom';

export function ClaimRequestSearch({ objectDto, setObjectDto, validate, setCounter, counter, setLoading }) {
    const [policyNo, setPolicyNo] = useState('80015430');
    const [listPo, setListPo] = useState([]);
    if (listPo.length === 0) ClaimService.getListPolicyNumber(setListPo, setObjectDto);
    const navigation = useNavigate();
    if (listPo === 401) navigation('/')
    return (
        <>
            <div data-toggle="collapse" data-target="#search-box-1" className={"header-box"} id="search-box-1">
                <h2 className="title-box description-large-customer">{t("claimpolicycheck").toUpperCase()}</h2>
            </div>
            <div className={"collapse in"} id="search-box-1">
                <div className="border-box-sc row" id="policyDiv" style={{ display: "block", padding: "0 2.5%" }}>
                    {/* checked === 0 */}
                    <fieldset className="policy-infor" style={{ display: objectDto.checked === 0 && objectDto.policyChecked === 0 ? "block" : "none" }}>
                        <div className="col-md-12 form-group">
                            <label className="col-md-4 required description-small-customer">{t("policynumber")}</label>
                            <div className="col-md-8">
                                <CustomAutocomplete placeholder={t("policylist")} value={policyNo} data={listPo}
                                    handleChange={(e) => handleChangeEventTextContent(e, setPolicyNo)}
                                />
                            </div>
                        </div>
                        <div className="footer-box-bg col-md-12">
                            <a id="btnCheck" className="btn-common btn-search description-small-customer" href
                                onClick={() => {
                                    setLoading(true);
                                    ClaimService.HandleVerifyToken(policyNo, setObjectDto, setLoading);
                                }} >
                                <i className="fa fa-info" aria-hidden="true" />{" "}
                                <span>{t("access")}</span>
                            </a>
                        </div>

                    </fieldset>

                    {/* checked > 0 */}
                    <fieldset className="policy-infor" hidden={!(objectDto.checked > 0)}>
                        <div className="col-md-12 form-group">
                            <ClaimRequestInfo objectDto={objectDto} setObjectDto={setObjectDto} validate={validate} />
                        </div>
                        <div className="form-group col-md-12" style={{ display: objectDto.checked === 1 ? "block" : "none", color: "#c4960c" }}>
                            <div className="col-md-12 description-small-customer">
                                <ul>
                                    <li>
                                        <i className="fa fa-ellipsis-h" aria-hidden="true" />
                                        <span className="" >{t("claimnoteemail1")}</span>
                                        <a href="*{linkClaim}" style={{ color: "#c4960c", fontWeight: "bold", fontStyle: "italic" }}>
                                            <u>
                                                <span text="*{formTitleClaim} + ' '" />
                                            </u>
                                        </a>
                                        <span className="">{t("claimnoteemail2")}</span>
                                    </li>
                                </ul>
                            </div>
                        </div>
                    </fieldset>
                </div>
            </div>
        </>
    )
}